import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getReportSetting, searchReportSetting } from '../../../redux/actions/reportSetting'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import CheckProjectQualityWidget from '../../../widgets/checkProjectQualityWidgets/CheckProjectQualityWidget'
import { getQualityCheckList } from '../../../redux/actions/subprojectQualityCheckList'

export default function CheckProjectQuality() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getQualityCheckList(null, null, 5, 1)
      setSchema(response)
      // setSchema(mockSchema.model)
      // console.log('mockSchema', mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <CheckProjectQualityWidget schema={schema} />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: null,
      searchForm: {
        header: null,
        projectCode: {
          name: 'projectCode',
          label: 'รหัสโครงการหลัก',
          value: null,
        },
        subProjectCode: {
          name: 'subProjectCode',
          label: 'รหัสโครงการย่อย',
          value: null,
        },
        projectComments: {
          name: 'projectComments',
          label: 'ความเห็นต่อโครงการ',
          value: null,
        },
        projectQualityLevel: {
          options: [
            {
              disabled: false,
              label: 'ดีมาก',
              value: '1',
            },
            {
              disabled: false,
              label: 'ดี',
              value: '2',
            },
            {
              disabled: false,
              label: 'ควรปรับปรุง',
              value: '3',
            },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก ความเห็นต่อโครงการ',
            },
          ],
          name: 'projectQualityLevel',
          label: 'ระดับคุณภาพโครงการ',
          value: null,
        },
        nannyQualityLevel: {
          options: [
            {
              disabled: false,
              label: 'ดีมาก',
              value: '1',
            },
            {
              disabled: false,
              label: 'ดี',
              value: '2',
            },
            {
              disabled: false,
              label: 'ควรปรับปรุง',
              value: '3',
            },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก ระดับคุณภาพพี่เลี้ยง',
            },
          ],
          name: 'nannyQualityLevel',
          label: 'ระดับคุณภาพพี่เลี้ยง',
          value: null,
        },
      },
      data: {
        totalSize: 6,
        values: [
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            qualityCheckDate: '01 ม.ค. 2566',
            projectCode: '65-10150',
            subProjectCode: '65-10150-03',
            projectQualityLevel: 'ดีมาก',
            nannyQualityLevel: 'ดี',
            subProjectName: 'ชุมชนสุขภาพดี ลดปัจจัยเสี่ยง เลี่ยงโรคNCds',
            commentator: 'นางสาวสุภัทรา เรืองวานิช',
            latestProjectComments: 'ควรปรับปรุง',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            qualityCheckDate: '30 มิ.ย. 2566',
            projectCode: '65-10150',
            subProjectCode: '65-10150-03',
            projectQualityLevel: 'ดี',
            nannyQualityLevel: 'ดีมาก',
            subProjectName: 'ส่งเสริมสุขภาพผู้สูงอายุด้วยหลัก 3 อ.',
            commentator: 'นางสาวสุภัทรา เรืองวานิช',
            latestProjectComments: 'ควรปรับปรุง',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            qualityCheckDate: '01 ก.ค. 2566',
            projectCode: '65-10150',
            subProjectCode: '65-10150-03',
            projectQualityLevel: 'ควรปรับปรุง',
            nannyQualityLevel: 'ควรปรับปรุง',
            subProjectName: 'ลดหวาน มันเค็ม เติมเต็มผักและผลไม้ ห่างไกลโรคเรื้อรัง',
            commentator: 'นางสาวสุภัทรา เรืองวานิช',
            latestProjectComments: 'ควรปรับปรุง',
            totalSize: 3,
          },
        ],
      },
    },
    header: 'รายการตรวจสอบคุณภาพโครงการย่อย',
    subHeader: null,
    disabled: true,
    isApprover: false,
  },
}
